class GalleryAlbumsSlider {
    constructor(el) {
        let gallerySingleClose      = $('[data-gallery-single-close]');
        this.el = el;

        let optsSlider = {
            slidesPerView: 'auto',
            // loopedSlides: 8,
            loop: true,
            speed: 1200,
            spaceBetween: 104,
            centeredSlides: true,
            navigation: {
                nextEl: '.GalleryAlbums_next',
                prevEl: '.GalleryAlbums_prev',
            },
            on: {
                init: () => {
                    // this.slideAnimating();
                    galleryAlbumsNavs.addClass(showClass);
                },
                touchStart: () => {
                    galleryAlbumsNavs.removeClass(showClass);
                },
                slideChangeTransitionStart: () => {
                    galleryAlbumsNavs.removeClass(showClass);
                },
                slideChangeTransitionEnd: () => {
                    galleryAlbumsNavs.addClass(showClass);
                },
                touchEnd: () => {
                    galleryAlbumsNavs.addClass(showClass);
                }
            },
            slideToClickedSlide: false,
            hashNavigation: {
                replaceState: true,
                watchState: true
            },
        };

        this.slider = new Swiper(el, optsSlider);
        console.log('this el', this.slider)
        // this.slideAnimating();
        // this.setSliderAlbumsNavPosition();
        // this.resetGalleryMobile();

        this.el.on('click', '.swiper-slide-next', () => {
            this.slider.slideNext();
        });

        this.el.on('click', '.swiper-slide-prev', () => {
            this.slider.slidePrev();
        });

        gallerySingleClose.on('click', function () {
            $body.removeClass(noScrollClass);
            gallerySingleCont.removeClass(showClass);
            gallerySingleSlider.removeAllSlides();
        });
    }

    slideAnimating() {
        console.log('this.slider', this.slider)
        let activeSlideIndex = this.slider.realIndex;
        let activeSlide      = this.el.find('[data-swiper-slide-index="'+ activeSlideIndex +'"]');
        let otherSlides      = this.el.find('[data-swiper-slide-index]');
        let windowSize       = $window.width();
        if (windowSize >= 1024) {
            otherSlides.find('.GalleryAlbums_img img').css({
                "transform": "translateY(49px)"
            });
            otherSlides.find('.GalleryAlbums_info').css({
                "transform": "translateY(-100%)"
            });
            activeSlide.find('.GalleryAlbums_img img').css({
                "transform": "translateY(0)"
            });
            activeSlide.find('.GalleryAlbums_info').css({
                "transform": "translateY(0)"
            });
        } else {
            otherSlides.find('.GalleryAlbums_img img').css({
                "transform": "translateY(0)"
            });
            otherSlides.find('.GalleryAlbums_info').css({
                "transform": "translateY(0)"
            });
            activeSlide.find('.GalleryAlbums_img img').css({
                "transform": "translateY(0)"
            });
            activeSlide.find('.GalleryAlbums_info').css({
                "transform": "translateY(0)"
            });
        }
    }

    setSliderAlbumsNavPosition() {
        let activeSlideWidth = this.slider.$el.find('.swiper-slide-active').outerWidth();
        let marginSlides     = parseInt(galleryAlbumsSlider.params.spaceBetween);
        let widthNav         = galleryAlbumsNext.outerWidth();
        let positionNav      = (activeSlideWidth / 2) + (marginSlides / 2) + (widthNav / 2);

        galleryAlbumsNext.css({
            'transform': 'translate3d(' + positionNav + 'px,-50%, 0)'
        });
        galleryAlbumsPrev.css({
            'transform': 'translate3d(' + (-positionNav) + 'px,-50%, 0)'
        });
    }

    resetGalleryMobile() {
        let width = $window.width();
        if (width < 1024) {
            this.slider.destroy();
        }
    }
}